export default __webpack_public_path__ + "media/images/archetypes/replier-e69c7ed034965e2ad063e572ffb169aa.png";